import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../features/auth/authContext.js';

export const ForgotPasswordPage: React.FC = () => {
  const auth = useAuth();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event: React.FormEvent<HTMLFormElement>): Promise<void> => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await auth.sendPasswordReset(email);
    } catch {
      // Intentionally swallow errors to prevent account enumeration and avoid client logging
    } finally {
      setMessage(
        'If an account exists for that email address, password recovery instructions have been sent.'
      );
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-form-page">
      <div className="auth-form-heading">
        <h2>Reset Your Password</h2>
        <p>Enter your email address to receive password recovery instructions.</p>
      </div>
      {message && (
        <p className="auth-form-message" role="status">
          {message}
        </p>
      )}
      <form className="auth-form" onSubmit={(event) => void submit(event)}>
        <label>
          Email Address
          <input
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <button type="submit" disabled={!auth.isConfigured || submitting}>
          {submitting ? 'Requesting…' : 'Send Reset Link'}
        </button>
      </form>
      <div className="auth-form-links auth-form-links-centered">
        Remembered your password? <Link to="/login">Sign in</Link>
      </div>
    </div>
  );
};
